<template>
  <div class="wraper clear">
    <div style="padding-bottom: 10px">
      <span>大数据首页</span>
      <el-tooltip placement="right">
        <div slot="content">
          在线设备：在线设备(已经投放在线上运行的设备)，离线设备(已经投放未在线
          <br />上运行的设备)。
          <br />累计客流：所有设备的累积客流量(开关门次数-补货次数)
          <br />平均纯净度：所有大数据冷柜纯净度平均值。
          <br />累计销售额：所有大数据冷柜销售额量总和(排除补货、退货状态后，各商品销
          <br />售数量*对应单价后金额总和)
          <br />累计销量：所有大数据冷柜销量总和(排除补货、退货状态后，各商品销售数量
          <br />
          总和）。
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
    </div>
    <div class="data-bash">
      <!-- <div class="col-5">
        <div class="data-bash-inner">
          <div class="inner-title">在线设备</div>
          <div class="inner-number">889/1000</div>
          <div class="inner-alt">在线/总数</div>
        </div>
      </div> -->
      <div class="col-5">
        <div class="data-bash-inner green">
          <div class="inner-title">累计客流量</div>
          <div class="inner-number">{{ sumCustomerFlow }}</div>
          <div class="inner-alt">人次</div>
        </div>
      </div>
      <div class="col-5">
        <div class="data-bash-inner purple">
          <div class="inner-title">平均纯净度</div>
          <div class="inner-number">{{ avgPurity }}</div>
          <div class="inner-alt">全部设备</div>
        </div>
      </div>
      <div class="col-5">
        <div class="data-bash-inner orange">
          <div class="inner-title">累计销售额</div>
          <div class="inner-number">￥{{ sumSalesAmount }}</div>
          <div class="inner-alt">全部设备</div>
        </div>
      </div>
      <div class="col-5">
        <div class="data-bash-inner red">
          <div class="inner-title">累计销量</div>
          <div class="inner-number">{{ sumSalesNum }}</div>
          <div class="inner-alt">全部设备</div>
        </div>
      </div>
    </div>
    <div>
      <div class="select-passenger-box">
        <div class="block">
          <span class="demonstration">客流统计趋势</span>
          <el-tooltip placement="right">
            <div slot="content">
              客流统计周趋势：展示7日客流统计趋势
              <br />通过折线图可查看7日趋势，可更换日期与筛选条件查看不同时间不同条件下的
              <br />客流统计
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
          <span style="font-size:12px;font-weight: bold"
            >{{ cusstartDate }} 至
          </span>
          <el-date-picker
            v-model="passengerDate"
            type="date"
            value-format="yyyy-MM-dd"
            @change="handlePassangerDateChange"
            :picker-options="pickerOptions"
            :clearable="clearDate"
            size="mini"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-button size="mini" type="default" @click="dialogVisible = true"
            >点击打开筛选条件</el-button
          >
          <el-button
            class="fr"
            type="primary"
            size="mini"
            @click="handleCustomDrawer"
            >TOP榜详情</el-button
          >
        </div>
      </div>
      <el-col :span="24" style="margin-bottom:30px">
        <ve-line
          :data="passengerFlow"
          class="bg-white"
          :extend="extend"
          :colors="colors"
        ></ve-line>
      </el-col>
    </div>
    <div>
      <div class="select-passenger-box">
        <div class="block">
          <span class="demonstration">销量统计趋势</span>
          <el-tooltip placement="right">
            <div slot="content">
              销量统计周趋势：展示7日销量统计趋势
              <br />通过折线图可查看7日趋势，可更换日期与筛选条件查看不同时间不同条件下的
              <br />销量统计
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
          <span style="font-size:12px;font-weight: bold"
            >{{ salestartDate }} 至
          </span>
          <el-date-picker
            v-model="salesDate"
            type="date"
            value-format="yyyy-MM-dd"
            @change="handleSalesDateChange"
            :picker-options="pickerOptions"
            :clearable="clearDate"
            size="mini"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-button type="default" size="mini" @click="dialogVisible1 = true"
            >点击打开筛选条件</el-button
          >
          <el-button
            class="fr"
            type="primary"
            size="mini"
            @click="handleSaleDrawer"
            >TOP榜详情</el-button
          >
        </div>
      </div>
      <el-col :span="24">
        <ve-line
          :data="salesVolume"
          class="bg-white"
          :extend="extend"
          :colors="colors"
        ></ve-line>
      </el-col>
    </div>
    <el-dialog title="筛选条件" :visible.sync="dialogVisible" width="50%">
      <dialog-box :selectOjb="selectOjb" @callFather="handleSun"></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="handlePrimary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="筛选条件" :visible.sync="dialogVisible1" width="50%">
      <dialog-box :selectOjb="selectOjb1" @callFather="handleSun"></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="handleSalesPrimary">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      :title="title"
      :visible.sync="custable"
      direction="rtl"
      size="40%"
    >
      <span style="margin:20px 0px 0px 12px;margin-left:12px;width: 95%"
        >客流量 前10</span
      >
      <div style="overflow-y:scroll; height: 40%;margin-bottom: 30px">
        <el-table :data="gridData" style="margin-left:12px;width: 95%">
          <el-table-column
            property="dataKey"
            label="资产号"
            width="150"
          ></el-table-column>
          <el-table-column
            property="dataLabel"
            label="经销商"
            width="200"
          ></el-table-column>
          <el-table-column
            property="dataValue"
            label="客流量"
          ></el-table-column>
        </el-table>
      </div>
      <span style="margin:20px 0px 0px 12px;margin-left:12px;width: 95%"
        >客流量 后10</span
      >
      <div style="overflow-y:scroll; height: 40%;margin-top: 5px">
        <el-table
          :data="gridData1"
          style="margin:20px 0px 0px 12px;margin-left:12px;width: 95%"
        >
          <el-table-column
            property="dataKey"
            label="资产号"
            width="150"
          ></el-table-column>
          <el-table-column
            property="dataLabel"
            label="经销商"
            width="200"
          ></el-table-column>
          <el-table-column
            property="dataValue"
            label="客流量"
          ></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-drawer
      :title="title"
      :visible.sync="saltable"
      direction="rtl"
      size="40%"
    >
      <span style="margin:20px 0px 0px 12px;margin-left:12px;width: 95%"
        >设备 TOP10</span
      >
      <div style="overflow-y:scroll; height: 25%;margin-bottom: 30px">
        <el-table :data="gridData" style="margin-left:12px;width: 95%">
          <el-table-column
            property="dataKey"
            label="资产号"
            width="150"
          ></el-table-column>
          <el-table-column
            property="dataLabel"
            label="经销商"
            width="200"
          ></el-table-column>
          <el-table-column property="dataValue" label="销量"></el-table-column>
        </el-table>
      </div>
      <span style="margin:20px 0px 0px 12px;margin-left:12px;width: 95%"
        >商品销量 TOP10</span
      >
      <div style="overflow-y:scroll; height: 30%;margin-top: 5px">
        <el-table :data="gridData1" style="margin:20px 0px 0px 12px;width: 95%">
          <el-table-column
            property="dataKey"
            label="商品名称"
            width="150"
          ></el-table-column>
          <el-table-column
            property="dataValue"
            label="销量"
            width="200"
          ></el-table-column>
          <el-table-column property="dataLabel" label="金额"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DialogBox from "./components/DialogBox";
// import axios from 'axios'
export default {
  name: "home",
  components: {
    DialogBox
  },
  data() {
    return {
      title: "",
      custable: false,
      saltable: false,
      gridData: [],
      gridData1: [],
      extend: {
        series: {
          smooth: false
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
        legend: {
          textStyle: {
            //图例文字的样式
            color: "#fff",
          
          }
        }
      },
      lineUrl: "data/getBigDataIndex_WeekTrend",
      topUrl: "data/getBigDataIndexTop",
      staticInfoUrl: "data/getBigDataIndex",
      cusstartDate: "-",
      salestartDate: "-",
      passengerDate: this.getPreDay(),
      salesDate: this.getPreDay(),
      clearDate: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        }
      },
      dialogVisible: false,
      dialogVisible1: false,
      sumCustomerFlow: "-",
      avgPurity: "-",
      sumSalesAmount: "-",
      sumSalesNum: "-",
      passengerFlow: {
        columns: ["日期", "客流量"],
        rows: []
      },
      salesVolume: {
        columns: ["日期", "销量"],
        rows: []
      },
      selectOjb: this.params(),
      selectOjb1: this.params(),
      colors: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3"
      ]
    };
  },
  created() {},
  mounted() {
    this.getStatisticsInfo(this.staticInfoUrl); // 获取信息看板数据
    this.getPassengersFlow(this.selectOjb, "customer_flow"); // 获取客流量统计折线图
    this.getPassengersFlow(this.selectOjb1, "sales_num"); // 获取销量统计折线图
    let date = new Date();
    date = new Date(date.getTime() - 1000 * 60 * 60 * 24);
    this.getDateInfo(date);
  },
  methods: {
    getDateInfo(date, obj) {
      date = new Date(date);
      let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 6);
      let endyear = enddate.getFullYear();
      let endmonth = enddate.getMonth() + 1;
      if (endmonth < 10) {
        endmonth = "0" + endmonth;
      }
      let endday = enddate.getDate();
      if (endday < 10) {
        endday = "0" + endday;
      }
      if (obj == undefined) {
        this.salestartDate = endyear + "-" + endmonth + "-" + endday;
        this.cusstartDate = endyear + "-" + endmonth + "-" + endday;
      } else {
        if (obj == "sales_num") {
          this.salestartDate = endyear + "-" + endmonth + "-" + endday;
        } else {
          this.cusstartDate = endyear + "-" + endmonth + "-" + endday;
        }
      }
    },
    getPreDay() {
      let date = new Date();
      date = new Date(date.getTime() - 1000 * 60 * 60 * 24);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    params() {
      return {
        agencyType: "",
        areaCompanyId: "",
        channelType: "",
        cityCode: "",
        companyId: "",
        dealerCompanyId: "",
        groupId: "",
        id: "",
        marketType: "",
        productModelType: "",
        provinceBranchCompanyId: "",
        provinceCode: "",
        putPolicy: "",
        secondChannelType: "",
        storeId: "",
        thirdChannelType: ""
      };
    },
    handlePassangerDateChange() {
      this.getPassengersFlow(this.selectOjb, "customer_flow");
      this.getDateInfo(this.passengerDate, "customer_flow");
    },
    handleSalesDateChange() {
      this.getPassengersFlow(this.selectOjb1, "sales_num");
      this.getDateInfo(this.salesDate, "sales_num");
    },
    getStatisticsInfo(url) {
      let _this = this;
      this.$ajax
        .get(url)
        .then(this.getStatisticsInfoSucc)
        .catch(function(res) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    getStatisticsInfoSucc(res) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data;
        this.sumCustomerFlow = data.sumCustomerFlow;
        this.avgPurity = data.avgPurity;
        this.sumSalesAmount = data.sumSalesAmount;
        this.sumSalesNum = data.sumSalesNum;
      } else {
        let errMsg = "未知错误";
        if (res.data.msg) {
          errMsg = res.data.msg;
        }
        this.$message.error(errMsg);
      }
    },
    getPassengersFlow(paramsObj, flowName) {
      let _this = this;
      let url = _this.lineUrl;
      let params = {
        fieldName: flowName
      };
      if (flowName == "sales_num") {
        params.endDay = this.salesDate;
      } else {
        params.endDay = this.passengerDate;
      }
      for (let k in paramsObj) {
        if (paramsObj[k] != "") params[k] = paramsObj[k];
      }
      this.$ajax
        .post(url, params)
        .then(function(res) {
          _this.getPassengersFlowSucc(res, flowName);
        })
        .catch(function(error) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    getPassengersFlowSucc(res, fieldName) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data;
        let flowList = [];
        for (let i = 0; i < data.length; i++) {
          if (fieldName === "customer_flow") {
            flowList.push({
              日期: data[i].chartX,
              客流量: data[i].chartY
            });
          } else {
            flowList.push({
              日期: data[i].chartX,
              销量: data[i].chartY
            });
          }
        }
        if (fieldName === "customer_flow") {
          this.passengerFlow.rows = flowList;
        } else {
          this.salesVolume.rows = flowList;
        }
      } else {
        let errMsg = "未知错误";
        if (res.data.msg) {
          errMsg = res.data.msg;
        }
        this.$message.error(errMsg);
      }
    },
    // 接收子组件传过来的数据
    handleSun(res) {
      //console.log(this.selectOjb);
    },
    handlePrimary() {
      this.dialogVisible = false;
      this.getPassengersFlow(this.selectOjb, "customer_flow");
    },
    handleSalesPrimary() {
      this.dialogVisible1 = false;
      this.getPassengersFlow(this.selectOjb1, "sales_num");
    },
    handleCustomDrawer() {
      this.custable = true;
      this.title =
        "客流量数据  " + this.cusstartDate + " 至  " + this.passengerDate;
      let _this = this;
      let url = _this.topUrl;
      let params = {
        fieldName: "customer_flow",
        endDay: _this.passengerDate
      };
      for (let k in this.selectOjb) {
        if (this.selectOjb[k] != "") params[k] = this.selectOjb[k];
      }
      console.log(params);
      this.$ajax
        .post(url, params)
        .then(function(res) {
          _this.CustomDrawerSucc(res);
        })
        .catch(function(error) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    handleSaleDrawer() {
      this.saltable = true;
      this.title = "销量数据  " + this.salestartDate + " 至  " + this.salesDate;
      let _this = this;
      let url = _this.topUrl;
      let params = {
        fieldName: "sales_num",
        endDay: _this.salesDate
      };
      for (let k in this.selectOjb1) {
        if (this.selectOjb1[k] != "") params[k] = this.selectOjb1[k];
      }
      console.log(params);
      this.$ajax
        .post(url, params)
        .then(function(res) {
          _this.CustomDrawerSucc(res);
        })
        .catch(function(error) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    CustomDrawerSucc(res) {
      if (res.data && res.data.code === 200) {
        this.gridData = res.data.data.topData;
        this.gridData1 = res.data.data.saleData;
      } else {
        let errMsg = "未知错误";
        if (res.data.msg) {
          errMsg = res.data.msg;
        }
        this.$message.error(errMsg);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.data-bash .col-5 {
  width: 25%;
  box-sizing: border-box;
  padding: 10px;
  float: left;
  margin-bottom: 20px;
}

.data-bash-inner {
  background: rgba(0, 0, 0, 0.25);
  height: 120px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  line-height: 1.6;
}

.green {
  background: rgba(0, 0, 0, 0.25);
}

.purple {
  /* background: #7839da; */
  background: rgba(0, 0, 0, 0.25);
}

.orange {
  /* background: #e48a07; */
  background: rgba(0, 0, 0, 0.25);
}

.red {
  /* background: #f01611; */
  background: rgba(0, 0, 0, 0.25);
}

.inner-title {
  line-height: 3;
}

.inner-number {
  font-size: 30px;
}

.inner-alt {
  text-align: right;
  padding: 0 20px;
}

.bg-white {
  background: rgba(0, 0, 0, 0.25);
}

.select-passenger-box {
  padding: 10px !important;
  /* background: rgba(0, 0, 0, 0.25); */
}

/deep/ :focus {
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue